import React from 'react';
import { appWithTranslation } from 'next-i18next';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { SecurityProvider } from '@dentalux/security';
import { HooksRunner } from 'src/components/HooksRunner/HooksRunner';
import { PageLoader } from 'src/components/PageLoader/PageLoader';
import RouteGuard from 'src/components/RouteGuard';
import nextI18nextConfig from 'src/config/nextI18next';
import securityHelpers from 'src/config/security';
import { usePostHog } from 'src/hooks/usePostHog';
import AllProviders from 'src/providers/AllProviders';
import 'src/styles/custom.css';
const MyApp = ({
  Component,
  pageProps
}) => {
  const router = useRouter();
  const {
    distinctId
  } = usePostHog(process.env.NEXT_PUBLIC_PH_PROJECT_API_KEY);
  const search = useSearchParams();
  if (typeof window === 'undefined') {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(SecurityProvider, {
    config: securityHelpers.getConfig({
      search,
      u_s: distinctId || 'not enabled'
    }),
    router: securityHelpers.createRouter(router)
  }, /*#__PURE__*/React.createElement(AllProviders, null, /*#__PURE__*/React.createElement(RouteGuard, {
    path: router.pathname
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, pageProps), /*#__PURE__*/React.createElement(PageLoader, null), /*#__PURE__*/React.createElement(HooksRunner, null)))));
};
export default appWithTranslation(MyApp, nextI18nextConfig);